import React from 'react';
// import Slick from 'react-slick';
import smoothScroll from 'smoothscroll';
// import SortSelect from 'components_v2/common/SortSelect';
// import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './VsTimeLineWrapper.scss';
import SwitchTabs from '../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';
import NewsStoryCard from '../../../components_v2/desktop/NewStoryCard';
import NewsStoryCardMobile from '../../../components_v2/mobile/NewStoryCard';
import { IMAGE_URL } from '../../../constants';

class VsTimeLineWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.tabs =
      this.props.sectionData?.items &&
      Object.keys(this.props.sectionData?.items).map((data, i) => ({
        name: this.props.sectionData?.items?.[data]?.name || '',
        key: data,
        index: i + 1,
      }));
    this.state = {
      activeTab: this.tabs[0],
    };
  }

  tabHandler = tab => {
    this.setState({ activeTab: tab });
    if (this.props.isWapView) {
      smoothScroll(0, 1000);
    }
  };

  render() {
    const timeLineData = this.props?.sectionData?.items?.[
      this.state.activeTab.key
    ];
    return (
      <div className={`${s.vsTimeLineWrapper} ${s[this.state.activeTab.key]}`}>
        <meta name="format-detection" content="telephone=no" />
        <div className={`${s.topTabWrap}`}>
          <div className={s.stWrap}>
            <SwitchTabs
              tabs={this.tabs}
              tabHandler={this.tabHandler}
              isToggle
            />
          </div>
        </div>
        {timeLineData.special_items && (
          <div className={s.bannerCardWrap}>
            <div className={s.profileContainer}>
              <ImageV2 src={`${IMAGE_URL}${timeLineData?.image}.cms`} alt="" />
              <div className={s.secTitleWrap}>
                <h2>{timeLineData?.name}</h2>
                <p>{timeLineData?.gov}</p>
              </div>
            </div>
            <div
              className={s.scContent}
              dangerouslySetInnerHTML={{
                __html: timeLineData.special_items.desc,
              }}
            />
          </div>
        )}
        {timeLineData.items &&
          Array.isArray(timeLineData.items) &&
          timeLineData.items.length > 0 &&
          timeLineData?.items.map(item => (
            <section className={s.usElectiontimeLineWrap}>
              <div className={s.timeLineWrap}>
                <div className={s.yearTextWrap}>
                  <span className={s.circleRing} />
                  {item.name}
                </div>
              </div>
              <div className={s.cardWrap}>
                {!this.props.isWapView ? (
                  <NewsStoryCard
                    title={item.desc}
                    msid={item.image}
                    cardType="card_24"
                  />
                ) : (
                  <NewsStoryCardMobile
                    title={item.desc}
                    msid={item.image}
                    cardType="card_18"
                  />
                )}
              </div>
            </section>
          ))}
      </div>
    );
  }
}

export default VsTimeLineWrapper;
